import React, { useContext } from 'react'
import { FaSearch } from 'react-icons/fa'
import Context from '../../../context'

function SearchField() {
  const { searchData, setSearchData } = useContext(Context)
  const handleSubmit = e => {
    e.preventDefault()

    if (searchData.str !== '') {
      setSearchData({ ...searchData, startSearch: true })
    }
  }

  return (
    <form noValidate autoComplete="off" onSubmit={e => handleSubmit(e)}>
      <div className="input-group ">
        <input
          style={{ marginBottom: '0px', marginTop: '0px' }}
          value={searchData.str}
          onChange={e => setSearchData({ ...searchData, str: e.target.value })}
          type="text"
          className="form-control"
          placeholder="Buscar..."
          aria-label="Buscar..."
        />
        <div className="input-group-prepend">
          <button className="btn btn-outline-secondary" type="submit">
            <FaSearch />
          </button>
        </div>
      </div>
    </form>
  )
}

export default SearchField
